var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"donut-box"},[_c('div',{staticClass:"donut-wrapper"},[_c('key-value',{staticClass:"donut-value",attrs:{"key-value":_vm.value,"percentage":_vm.percentage}}),_c('div',{ref:"donut",staticClass:"ct-chart ct-square"})],1),_c('div',{staticClass:"text-semibold"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }